import { render, staticRenderFns } from "./WorkflowSettings.vue?vue&type=template&id=2a90d219&"
import script from "./WorkflowSettings.vue?vue&type=script&lang=js&"
export * from "./WorkflowSettings.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowSettings.vue?vue&type=style&index=0&id=2a90d219&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports